import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from  "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";
import {TableColumn} from "./tableColumn.mjs";
import {TableRow} from "./tableRow.mjs";

const table = tokenDefinition({
  name: TokenName.TABLE,
  type: TokenType.KEYWORD,
  tokenMatcher: /^@table\n/,
  contentMatcher: /^@table\n/
});

class Table {

  constructor() {
  }

  consume(tokenIterator, nodeIterator) {
    // When the column is closed by | cancel every node inside
    // When the row is closed by \n cancel every node inside
    // When the table is closed by \n\n close it

    if(this.isOpening(tokenIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }else if(this.isClosing(tokenIterator, nodeIterator)) {
      this.closeNode(tokenIterator, nodeIterator)
    }
  }

  isOpening(tokenIterator) {
    return tokenIterator.token()
        && tokenIterator.token().name === TokenName.TABLE
  }

  isClosing(tokenIterator, nodeIterator) {
    return !tokenIterator.token()
        ||(nodeIterator.currentParentNode.name === NodeName.TABLE
            && this.isDoubleLineFeed(tokenIterator))
  }

  isDoubleLineFeed(tokenIterator) {
    return tokenIterator.token().name === TokenName.LINE_FEED
  }

  openNewNode(tokenIterator, nodeIterator) {

    nodeIterator.addOpenNode(new Node(
        NodeName.TABLE,
        tokenIterator.token().value,
        new Table(),
        nodeIterator.currentParentNode
    ))
    tokenIterator.eatTokens(1)
  }

  closeNode(tokenIterator, nodeIterator) {
    // find table node and close it
    let openNodeIndex = nodeIterator.indexOfLastOpen(NodeName.TABLE)
    if(openNodeIndex === null) return
    nodeIterator.closeNodeAtIndex(openNodeIndex)

    // eat final LineFeed
    tokenIterator.eatTokens(1)

  }

  toHtml(node, toHtml, idProvider) {
    var content = ""
    for(const child of node.children) {
      content += toHtml(child, idProvider)
    }

    return "<table class='lecture__table'>" + content + "</table>"
  }

  onEndOfMarkup(openNode) {
    openNode.close()
  }

}
export {table, Table}